export default __webpack_public_path__ + "static/media/start-end-date.962b21b1.png";